import React from 'react';
import {twMerge} from 'tailwind-merge';

export const ColorPaletteSegments = ({
  colors,
  className,
}: {
  colors: readonly string[];
  className?: string;
}) => {
  const seenCounts = new Map<string, number>();

  return (
    <div className="flex w-full gap-x-2">
      {colors.map(color => {
        const seenCount = seenCounts.get(color) ?? 0;
        seenCounts.set(color, seenCount + 1);
        return (
          <div
            key={`${color}-${seenCount}`}
            style={{backgroundColor: color}}
            className={twMerge(
              'h-12 w-full first:rounded-l-lg last:rounded-r-lg',
              className
            )}
          />
        );
      })}
    </div>
  );
};
